import { FaFacebook, FaInstagram } from "react-icons/fa";

export const footerContentData = {
    title: "About us",
    description: "TTreasure Music Store is Nepal’s full-fledged online musical instruments store. We are the exclusive authorized distributor of Manaslu, Native Instruments, Laney, Alctron, Beyerdynamic, Hex Instruments, MXL Mics, and Stagg Music for Nepal. We proudly deal in the best brands like Fender, Squier, Epiphone, KRK, Yamaha, Roland, Epiphone, Focusrite, Shure, etc. Pay us a visit if you are looking for the best Guitar Shop in Nepal",
    socialLinks: [{
        icon: <FaFacebook />,
        link: "https://www.facebook.com/"
    },
    {
        icon: <FaInstagram />,
        link: "https://www.instagram.com/"
    }],

    youtube:

    {
        title: "Subscribe to our YouTube Channel",
    },

    newsLetter:
    {
        title: "Signup For Newsletter",
        description: "Together, we create awesome music that touches millions of hearts. Subscribe to our newsletter for the latest updates and offers. "
    }



}


export default footerContentData



